/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObject1Dto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LegalDocumentTypeDto } from '../models';
// @ts-ignore
import type { LegalDocumentVersionDto } from '../models';
// @ts-ignore
import type { LegalDocumentVersionsResponseDto } from '../models';
/**
 * LegalDocumentsManagementApi - axios parameter creator
 * @export
 */
export const LegalDocumentsManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Usuwa plik z S3 i wiersz metadanych. Obowiązującej wersji usunąć się nie da (409) — najpierw trzeba wskazać inną jako aktualną. Wymaga admin.legal.documents.edit. 
         * @summary Usuń wersję dokumentu prawnego (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLegalDocumentVersion: async (documentType: LegalDocumentTypeDto, documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('deleteLegalDocumentVersion', 'documentType', documentType)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteLegalDocumentVersion', 'documentId', documentId)
            const localVarPath = `/api/v1/admin/legal-documents/{documentType}/versions/{documentId}`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wszystkie opublikowane wersje, od najnowszej. Wymaga admin.legal.documents.view.
         * @summary Lista wersji dokumentu prawnego (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegalDocumentVersions: async (documentType: LegalDocumentTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('getLegalDocumentVersions', 'documentType', documentType)
            const localVarPath = `/api/v1/admin/legal-documents/{documentType}/versions`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pozwala wrócić do starszego brzmienia bez ponownego wgrywania pliku. Wymaga admin.legal.documents.edit.
         * @summary Ustaw wskazaną wersję jako obowiązującą (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCurrentLegalDocumentVersion: async (documentType: LegalDocumentTypeDto, documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('setCurrentLegalDocumentVersion', 'documentType', documentType)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('setCurrentLegalDocumentVersion', 'documentId', documentId)
            const localVarPath = `/api/v1/admin/legal-documents/{documentType}/versions/{documentId}/current`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Plik trafia do S3, w bazie zostają metadane, a nowa wersja od razu staje się obowiązującą — pod niezmienionym adresem pobierania. Dozwolony wyłącznie PDF, maksymalnie 8 MB. Wymaga admin.legal.documents.edit. 
         * @summary Opublikuj nową wersję dokumentu prawnego (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {File} file Plik PDF z treścią dokumentu
         * @param {string} [title] Opcjonalna nazwa wersji widoczna w panelu administracyjnym
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLegalDocumentVersion: async (documentType: LegalDocumentTypeDto, file: File, title?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('uploadLegalDocumentVersion', 'documentType', documentType)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadLegalDocumentVersion', 'file', file)
            const localVarPath = `/api/v1/admin/legal-documents/{documentType}/versions`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegalDocumentsManagementApi - functional programming interface
 * @export
 */
export const LegalDocumentsManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegalDocumentsManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Usuwa plik z S3 i wiersz metadanych. Obowiązującej wersji usunąć się nie da (409) — najpierw trzeba wskazać inną jako aktualną. Wymaga admin.legal.documents.edit. 
         * @summary Usuń wersję dokumentu prawnego (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLegalDocumentVersion(documentType: LegalDocumentTypeDto, documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLegalDocumentVersion(documentType, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalDocumentsManagementApi.deleteLegalDocumentVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wszystkie opublikowane wersje, od najnowszej. Wymaga admin.legal.documents.view.
         * @summary Lista wersji dokumentu prawnego (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLegalDocumentVersions(documentType: LegalDocumentTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalDocumentVersionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLegalDocumentVersions(documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalDocumentsManagementApi.getLegalDocumentVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pozwala wrócić do starszego brzmienia bez ponownego wgrywania pliku. Wymaga admin.legal.documents.edit.
         * @summary Ustaw wskazaną wersję jako obowiązującą (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCurrentLegalDocumentVersion(documentType: LegalDocumentTypeDto, documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalDocumentVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCurrentLegalDocumentVersion(documentType, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalDocumentsManagementApi.setCurrentLegalDocumentVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Plik trafia do S3, w bazie zostają metadane, a nowa wersja od razu staje się obowiązującą — pod niezmienionym adresem pobierania. Dozwolony wyłącznie PDF, maksymalnie 8 MB. Wymaga admin.legal.documents.edit. 
         * @summary Opublikuj nową wersję dokumentu prawnego (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {File} file Plik PDF z treścią dokumentu
         * @param {string} [title] Opcjonalna nazwa wersji widoczna w panelu administracyjnym
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadLegalDocumentVersion(documentType: LegalDocumentTypeDto, file: File, title?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalDocumentVersionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLegalDocumentVersion(documentType, file, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalDocumentsManagementApi.uploadLegalDocumentVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegalDocumentsManagementApi - factory interface
 * @export
 */
export const LegalDocumentsManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegalDocumentsManagementApiFp(configuration)
    return {
        /**
         * Usuwa plik z S3 i wiersz metadanych. Obowiązującej wersji usunąć się nie da (409) — najpierw trzeba wskazać inną jako aktualną. Wymaga admin.legal.documents.edit. 
         * @summary Usuń wersję dokumentu prawnego (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLegalDocumentVersion(documentType: LegalDocumentTypeDto, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLegalDocumentVersion(documentType, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Wszystkie opublikowane wersje, od najnowszej. Wymaga admin.legal.documents.view.
         * @summary Lista wersji dokumentu prawnego (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegalDocumentVersions(documentType: LegalDocumentTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<LegalDocumentVersionsResponseDto> {
            return localVarFp.getLegalDocumentVersions(documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Pozwala wrócić do starszego brzmienia bez ponownego wgrywania pliku. Wymaga admin.legal.documents.edit.
         * @summary Ustaw wskazaną wersję jako obowiązującą (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCurrentLegalDocumentVersion(documentType: LegalDocumentTypeDto, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<LegalDocumentVersionDto> {
            return localVarFp.setCurrentLegalDocumentVersion(documentType, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Plik trafia do S3, w bazie zostają metadane, a nowa wersja od razu staje się obowiązującą — pod niezmienionym adresem pobierania. Dozwolony wyłącznie PDF, maksymalnie 8 MB. Wymaga admin.legal.documents.edit. 
         * @summary Opublikuj nową wersję dokumentu prawnego (admin)
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {File} file Plik PDF z treścią dokumentu
         * @param {string} [title] Opcjonalna nazwa wersji widoczna w panelu administracyjnym
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLegalDocumentVersion(documentType: LegalDocumentTypeDto, file: File, title?: string, options?: RawAxiosRequestConfig): AxiosPromise<LegalDocumentVersionDto> {
            return localVarFp.uploadLegalDocumentVersion(documentType, file, title, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegalDocumentsManagementApi - interface
 * @export
 * @interface LegalDocumentsManagementApi
 */
export interface LegalDocumentsManagementApiInterface {
    /**
     * Usuwa plik z S3 i wiersz metadanych. Obowiązującej wersji usunąć się nie da (409) — najpierw trzeba wskazać inną jako aktualną. Wymaga admin.legal.documents.edit. 
     * @summary Usuń wersję dokumentu prawnego (admin)
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsManagementApiInterface
     */
    deleteLegalDocumentVersion(documentType: LegalDocumentTypeDto, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Wszystkie opublikowane wersje, od najnowszej. Wymaga admin.legal.documents.view.
     * @summary Lista wersji dokumentu prawnego (admin)
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsManagementApiInterface
     */
    getLegalDocumentVersions(documentType: LegalDocumentTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<LegalDocumentVersionsResponseDto>;

    /**
     * Pozwala wrócić do starszego brzmienia bez ponownego wgrywania pliku. Wymaga admin.legal.documents.edit.
     * @summary Ustaw wskazaną wersję jako obowiązującą (admin)
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsManagementApiInterface
     */
    setCurrentLegalDocumentVersion(documentType: LegalDocumentTypeDto, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<LegalDocumentVersionDto>;

    /**
     * Plik trafia do S3, w bazie zostają metadane, a nowa wersja od razu staje się obowiązującą — pod niezmienionym adresem pobierania. Dozwolony wyłącznie PDF, maksymalnie 8 MB. Wymaga admin.legal.documents.edit. 
     * @summary Opublikuj nową wersję dokumentu prawnego (admin)
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {File} file Plik PDF z treścią dokumentu
     * @param {string} [title] Opcjonalna nazwa wersji widoczna w panelu administracyjnym
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsManagementApiInterface
     */
    uploadLegalDocumentVersion(documentType: LegalDocumentTypeDto, file: File, title?: string, options?: RawAxiosRequestConfig): AxiosPromise<LegalDocumentVersionDto>;

}

/**
 * LegalDocumentsManagementApi - object-oriented interface
 * @export
 * @class LegalDocumentsManagementApi
 * @extends {BaseAPI}
 */
export class LegalDocumentsManagementApi extends BaseAPI implements LegalDocumentsManagementApiInterface {
    /**
     * Usuwa plik z S3 i wiersz metadanych. Obowiązującej wersji usunąć się nie da (409) — najpierw trzeba wskazać inną jako aktualną. Wymaga admin.legal.documents.edit. 
     * @summary Usuń wersję dokumentu prawnego (admin)
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsManagementApi
     */
    public deleteLegalDocumentVersion(documentType: LegalDocumentTypeDto, documentId: number, options?: RawAxiosRequestConfig) {
        return LegalDocumentsManagementApiFp(this.configuration).deleteLegalDocumentVersion(documentType, documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wszystkie opublikowane wersje, od najnowszej. Wymaga admin.legal.documents.view.
     * @summary Lista wersji dokumentu prawnego (admin)
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsManagementApi
     */
    public getLegalDocumentVersions(documentType: LegalDocumentTypeDto, options?: RawAxiosRequestConfig) {
        return LegalDocumentsManagementApiFp(this.configuration).getLegalDocumentVersions(documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pozwala wrócić do starszego brzmienia bez ponownego wgrywania pliku. Wymaga admin.legal.documents.edit.
     * @summary Ustaw wskazaną wersję jako obowiązującą (admin)
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsManagementApi
     */
    public setCurrentLegalDocumentVersion(documentType: LegalDocumentTypeDto, documentId: number, options?: RawAxiosRequestConfig) {
        return LegalDocumentsManagementApiFp(this.configuration).setCurrentLegalDocumentVersion(documentType, documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Plik trafia do S3, w bazie zostają metadane, a nowa wersja od razu staje się obowiązującą — pod niezmienionym adresem pobierania. Dozwolony wyłącznie PDF, maksymalnie 8 MB. Wymaga admin.legal.documents.edit. 
     * @summary Opublikuj nową wersję dokumentu prawnego (admin)
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {File} file Plik PDF z treścią dokumentu
     * @param {string} [title] Opcjonalna nazwa wersji widoczna w panelu administracyjnym
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsManagementApi
     */
    public uploadLegalDocumentVersion(documentType: LegalDocumentTypeDto, file: File, title?: string, options?: RawAxiosRequestConfig) {
        return LegalDocumentsManagementApiFp(this.configuration).uploadLegalDocumentVersion(documentType, file, title, options).then((request) => request(this.axios, this.basePath));
    }
}

